import { render, staticRenderFns } from "./SelectSoftType.vue?vue&type=template&id=2d313119&scoped=true&"
import script from "./SelectSoftType.vue?vue&type=script&lang=js&"
export * from "./SelectSoftType.vue?vue&type=script&lang=js&"
import style0 from "./SelectSoftType.vue?vue&type=style&index=0&id=2d313119&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d313119",
  null
  
)

export default component.exports